import { render } from "./TitleWithAction.vue?vue&type=template&id=a1c4ce60&scoped=true"
import script from "./TitleWithAction.vue?vue&type=script&lang=js"
export * from "./TitleWithAction.vue?vue&type=script&lang=js"

import "./TitleWithAction.vue?vue&type=style&index=0&id=a1c4ce60&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1c4ce60"]])

export default __exports__